export function stringWithDefault(value?: string): string {
  return value || "-";
}
